const bagasseContext = require.context(
  "../assets/products/bagasse",
  false,
  /\.(png|jpe?g|webp)$/i
);

const categoryOrder = [
  "Plates",
  "Bowls",
  "Trays",
  "Clamshell Boxes",
  "Cups",
  "Cutlery",
];

const categoryDescriptions = {
  Plates:
    "Round and compartment plates for dining, catering, and eco-conscious meal service.",
  Bowls:
    "Molded bagasse bowls suited to curries, sides, desserts, and takeaway applications.",
  Trays:
    "Meal trays and serving formats built for organized presentation and practical handling.",
  "Clamshell Boxes":
    "Takeaway-ready hinged packs for transport, sealing, and convenient food service delivery.",
  Cups:
    "Small-volume molded fiber cups for tasting portions, condiments, and edible cup programs.",
  Cutlery:
    "Compostable bagasse cutlery pieces for complete table service assortments.",
};

function toSlug(value) {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

function formatProductName(fileName) {
  const rawName = fileName.replace(/\.[^.]+$/, "").replace(/^TIV[-_\s]*/i, "");
  const cleaned = rawName
    .replace(/_/g, " ")
    .replace(/×/g, " x ")
    .replace(/\bknief\b/gi, "Knife")
    .replace(/\bcp\b/gi, "CP")
    .replace(/\bml\b/gi, "ml")
    .replace(/\b3cp\b/gi, "3CP")
    .replace(/\b2cp\b/gi, "2CP")
    .replace(/\b5cp\b/gi, "5CP")
    .replace(/\b8cp\b/gi, "8CP")
    .replace(/\s+/g, " ")
    .trim();

  return cleaned
    .split(" ")
    .map((word) => {
      if (!word) {
        return word;
      }

      if (/^\d/.test(word) || word === "CP" || word === "ml") {
        return word;
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ")
    .replace(/\bCp\b/g, "CP")
    .replace(/\bMl\b/g, "ml");
}

function detectCategory(fileName) {
  const normalized = fileName.toLowerCase();

  if (/(fork|spoon|knife|knief|cutlery)/.test(normalized)) {
    return "Cutlery";
  }

  if (/(clamshell|clam shell|box|4x4|4×4)/.test(normalized)) {
    return "Clamshell Boxes";
  }

  if (/\b90ml\b|\b100ml\b|\b240ml\b|\bcup\b/.test(normalized)) {
    return "Cups";
  }

  if (
    /(bowl|oval|depth|kiwi|1602|602|702|750ml|802|500ml)/.test(normalized)
  ) {
    return "Bowls";
  }

  if (/\bplate\b/.test(normalized)) {
    return "Plates";
  }

  if (/(tray|meal|square|3cp|2cp|8cp|1d)/.test(normalized)) {
    return "Trays";
  }

  return "Plates";
}

function buildDescription(category, productName) {
  switch (category) {
    case "Plates":
      return `${productName} is part of our bagasse plate range for eco-friendly dining, catering, and food service use.`;
    case "Bowls":
      return `${productName} is a molded fiber bowl suited to practical serving, takeaway, and sustainable packaging programs.`;
    case "Trays":
      return `${productName} belongs to our bagasse tray range for organized meal presentation and export-ready food packaging.`;
    case "Clamshell Boxes":
      return `${productName} is a bagasse clamshell option designed for convenient takeaway and clean, sustainable food packing.`;
    case "Cups":
      return `${productName} is a compact bagasse cup format suited to portions, tasting use, and specialty food service needs.`;
    case "Cutlery":
      return `${productName} is part of our bagasse cutlery range for neat, eco-conscious table service and events.`;
    default:
      return `${productName} is part of our export-ready bagasse range for buyers seeking sustainable food-service packaging.`;
  }
}

export const bagasseProducts = bagasseContext
  .keys()
  .map((key) => {
    const fileName = key.replace("./", "");
    const category = detectCategory(fileName);
    const name = formatProductName(fileName);

    return {
      id: toSlug(fileName),
      fileName,
      name,
      category,
      image: bagasseContext(key),
      description: buildDescription(category, name),
    };
  })
  .sort((left, right) => {
    const categoryDelta =
      categoryOrder.indexOf(left.category) - categoryOrder.indexOf(right.category);

    if (categoryDelta !== 0) {
      return categoryDelta;
    }

    return left.name.localeCompare(right.name);
  });

export const bagasseCategories = categoryOrder.map((category) => {
  const products = bagasseProducts.filter((product) => product.category === category);

  return {
    id: toSlug(category),
    name: category,
    count: products.length,
    description: categoryDescriptions[category],
    previewImage: products[0]?.image,
  };
});

export const bagasseCategoryOrder = categoryOrder;
